import { generateColorMap } from '@/common/utils/handle-color.js';

export default function(params, exclude) {
    return {
        computed: {
            colorStyle() {
                return generateColorMap.call(this, params, exclude);
            }
        }
    };
}
